import { ActionType, PatientChartInfo, SetPatientInfo } from 'types';

/**
 * Set patient info for patients who identify themselves via filling out demographics,
 * rather than logging into passport.
 */
export const setPatientInfo = (patient: PatientChartInfo): SetPatientInfo => ({
  payload: { patient },
  type: ActionType.SetPatientInfo,
});
